import type React from 'react';
import { Box, Button, ButtonGroup, Icon, Paragraph } from '@zillow/constellation-10';
import { IconWarningOutline } from '@zillow/constellation-icons';
import Modal from '@common/components/ConstellationV10Modal';
import userPersonas from '@common/constants/userPersonas';

type Props = {
  exitPaymentSetup: () => void;
  onBack: () => void;
};

const ExitPaymentSetup: React.FC<React.PropsWithChildren<Props>> = (props: Props): React.ReactElement => {
  return (
    <Modal
      persona={userPersonas.LANDLORD}
      onRequestClose={props.exitPaymentSetup}
      header="Exit payment setup?"
      body={
        <Box
          css={{
            display: 'grid',
            textAlign: 'center',
            gridTemplateRows: 'auto',
            gap: 'default',
          }}
        >
          <Box>
            <Icon
              size="xl"
              css={{
                color: 'blue.400',
              }}
            >
              <IconWarningOutline />
            </Icon>
          </Box>
          <Box>
            <Paragraph>For your security, your progress won&apos;t be saved</Paragraph>
          </Box>
          <Box>
            <Paragraph>
              If you exit, any information you entered during payment setup won&apos;t be saved. When you&apos;re ready
              to set up payments, restart the process.
            </Paragraph>
          </Box>
        </Box>
      }
      footer={
        <ButtonGroup aria-label="modal actions">
          <Button onClick={props.onBack}>Back to setup</Button>
          <Button emphasis="filled" onClick={props.exitPaymentSetup}>
            Yes, exit
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default ExitPaymentSetup;
